import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// views
import KodeAkun from "views/admin/masterData/kodeAkun/KodeAkun";
import UnitUsaha from "views/admin/masterData/unitUsaha/UnitUsaha";
import Pelanggan from "views/admin/masterData/pelanggan/Pelanggan";
import AnggaranPemasukan from "views/admin/masterData/anggaranPemasukan/AnggaranPemasukan";
import AnggaranPengeluaran from "views/admin/masterData/anggaranPengeluaran/AnggaranPengeluaran";
import DataAsset from "views/admin/masterData/dataAsset/DataAsset";
import Marketing from "views/admin/masterData/marketing/Marketing";
import DataTahun from "views/admin/masterData/dataTahun/DataTahun";
// import { useHistory } from "react-router-dom";
// import { authCekLogin } from "views/auth/login/api/loginAPI";
// import Auth from "./Auth";
// import Index from "views/Index";

export default function MasterData() {
  // const history = useHistory();

  // const [isLoggedIn, setIsLoggedIn] = useState(false);

  // const [resultLogin, setResultLogin] = useState(null);
  // const [errorsLogin, setErrorsLogin] = useState(null);

  // // Cek Login
  // useEffect(() => {
  //   authCekLogin()
  //     .then((response) => setResultLogin(response))
  //     .catch((err) => setErrorsLogin(err));
  // });

  // // Check If Request Failed
  // useEffect(() => {
  //   if (errorsLogin !== null) {
  //     console.error(errorsLogin.message);
  //   }
  // }, [errorsLogin]);

  // // Check If Request Success
  // useEffect(() => {
  //   if (resultLogin !== null) {
  //     if (resultLogin.data.success === true) {
  //       if (resultLogin.data.data.id_user !== null) {
  //         setIsLoggedIn(true);
  //       }
  //     } else {
  //       let numericArray = [];
  //       for (let err in resultLogin.data.errors) {
  //         numericArray.push(resultLogin.data.errors[err]);
  //       }
  //       numericArray.forEeach((err) => {
  //         console.log(err);
  //       });
  //       setIsLoggedIn(false);
  //       history.push("/");
  //     }
  //   }
  // }, [resultLogin, history]);

  // if (isLoggedIn === true) {
  //   <Switch>
  //     <Route path="/auth" component={Auth} />
  //     <Route path="/" exact component={Index} />
  //     <Redirect from="*" to="/" />
  //   </Switch>;
  // }

  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full h-screen -m-24">
          <Switch>
            <Route path="/masterData/KodeAkun" exact component={KodeAkun} />
            <Route path="/masterData/UnitUsaha" exact component={UnitUsaha} />
            <Route path="/masterData/Pelanggan" exact component={Pelanggan} />
            <Route path="/masterData/Marketing" exact component={Marketing} />
            <Route
              path="/masterData/AnggaranPemasukan"
              exact
              component={AnggaranPemasukan}
            />
            <Route
              path="/masterData/AnggaranPengeluaran"
              exact
              component={AnggaranPengeluaran}
            />
            <Route path="/masterData/DataAsset" exact component={DataAsset} />
            <Route path="/masterData/DataTahun" exact component={DataTahun} />
            <Redirect from="/masterData" to="/masterData/KodeAkun" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
